import * as React from 'react';
import getEventsById from 'Client/redux/eventsQueue/selectors';
import { useBellaSelector } from 'Client/redux/hooks';
import { ONETRUST_CONSENT_READY_EVENT_NAME } from 'Client/WestwingEventHandler';
import useConfig from 'Client/hooks/useConfig';
import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import useSegments from 'Client/hooks/useSegments';

const useHotjar = () => {
    const { hotjarId: id } = useConfig();
    const { e2eSegment, botSegment } = useSegments();
    const { p100HotjarTracker } = useFeatureToggle();
    const eventsQueue = useBellaSelector(state => state.eventsQueue);
    const oneTrustConsentReady = getEventsById(eventsQueue, ONETRUST_CONSENT_READY_EVENT_NAME);
    const haveConsentForTargetingCookies: boolean | undefined = oneTrustConsentReady?.data?.targetingCookies;

    React.useEffect(() => {
        if (
            e2eSegment ||
            botSegment ||
            typeof window.hj === 'function' ||
            !p100HotjarTracker ||
            !haveConsentForTargetingCookies ||
            !id
        ) {
            return () => null;
        }
        const hotjarScriptEl = document.createElement('script');
        hotjarScriptEl.setAttribute('data-testid', 'hotjar-wrapper-script');
        hotjarScriptEl.setAttribute('type', 'application/javascript');
        hotjarScriptEl.textContent = `(function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:${id},hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.defer=1;r.setAttribute('data-testid', 'hotjar-script');
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
        document.body.appendChild(hotjarScriptEl);

        return () => {
            document.body.removeChild(hotjarScriptEl);
        };
    }, [botSegment, haveConsentForTargetingCookies, id, p100HotjarTracker, e2eSegment]);

    return {
        sendOverlayTrigger: (triggerName: string) => {
            if (typeof window !== 'undefined' && window.hj) {
                window.hj('trigger', triggerName);
            }
        },
        sendCustomHotjarEvents: (event: string) => {
            if (typeof window !== 'undefined' && window.hj) {
                window.hj('event', event);
            }
        },
    };
};

export default useHotjar;
